import { render, staticRenderFns } from "./NuevoPago.vue?vue&type=template&id=0217a9aa"
import script from "./NuevoPago.vue?vue&type=script&lang=js"
export * from "./NuevoPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports